/**
 * @extends com.inq.flash.client.control.messagehandlers.ClientCommandMessageHandler
 * @constructor
 */
com.inq.flash.client.control.messagehandlers.CMSDKCommandMessageHandler = function() {
	this.constructor.__super__.call(this);
};
$hxClasses.extend(com.inq.flash.client.control.messagehandlers.ClientCommandMessageHandler,com.inq.flash.client.control.messagehandlers.CMSDKCommandMessageHandler,"com.inq.flash.client.control.messagehandlers.CMSDKCommandMessageHandler")


com.inq.flash.client.control.messagehandlers.CMSDKCommandMessageHandler.prototype.processCommand = function (message, replay) {
	if (com.inq.flash.client.control.FlashPeer.isMultiChatSupported()) { //RTDEV-23774: For multiple window chat support
		var masterWindowId = message.getProperty(com.inq.flash.client.data.MessageFields.MASTER_WINDOW_ID);
		// This windowId comparison needs to be done for the first time and not during replay.
		if (!replay && masterWindowId != "" && masterWindowId != com.inq.flash.client.control.FlashVars.getWindowId()) {
			return;
		}
	}
	/** @type {?string} */
	var cmd = message.getProperty(com.inq.flash.client.data.MessageFields.KEY_CLIENT_CMD_PARAM) || message.getProperty(com.inq.flash.client.data.MessageFields.KEY_CLIENT_COMMAND_PARAM);

	/** @type {string} */
	var pageURL = cmd;
	/** @type {string} */
	var sTarget = "inqNewWindow";
	/** @type {number} */
	var indx;
	/** @type {string} */
	var newCmdPr = "client_command";
	/** @type {string} */
	var CLIENT_FUNCTION = "client_function";

	if (pageURL.startsWith(newCmdPr)) {
		/*  pageURL contains cmdType + cmdParam*/
		com.inq.flash.client.chatskins.SkinControl.executeCustomCommand(HxOverrides.substr(pageURL, newCmdPr.length, null));
		return;
	}

	if ((indx = pageURL.indexOf(" to ")) >= 0) {
		sTarget = HxOverrides.substr(pageURL, indx + 4, null);
		pageURL = HxOverrides.substr(pageURL, 0, indx);
	}

	if (pageURL.startsWith(CLIENT_FUNCTION) && !replay) {
		com.inq.flash.client.chatskins.SkinControl.executeCustomCommand(
			JSON.stringify({
				"cmdType": CLIENT_FUNCTION,
				"cmdParam": HxOverrides.substr(pageURL, CLIENT_FUNCTION.length, null).trim(),
				"functionName": sTarget.trim()
			}));
		return;
	}

	this.controller.onNewChatRouterMessage(message);

	if (replay) {
		return;
	}


	if (pageURL == "goToPersistentChat") {
		// may need to add this capability
    } else if (pageURL != "xform" && pageURL != "show_input" && pageURL != "hide_input") {
		this.executeUrlRedirect(pageURL, sTarget);
	}
};
